<template>
  <sa-page-layout :pathResource="pathResource" btnEditVisible :linkedit="linkedit" :data="jsonData" btnRouterBackVisible :btnRefreshVisible="false" @refresh="onRefresh">
    <template slot="toolbar"> </template>
    <template slot="table-header">
      <contabilita-documento-dati-view-compontent ref="cmpContabilitaDocumentoDatiViewCompontent" />
    </template>
    <template slot="table-body">
      <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill>
        <b-tab title="Righe Documento" active>
          <contabilita-documento-righe-view-component ref="cmpContabilitaDocumentoRigheViewComponent" />
        </b-tab>
        <b-tab title="Riepilogo">
          <contabilita-riepilogo-component ref="cmpContabilitaDocumentoRiepologoComponent" />
        </b-tab>
      </b-tabs>
    </template>
    <template slot="table-footer">
      <div style="padding: 5px">
        <b-row class="text-center">
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <span class="sa-label-data"><b>Totale Imponibile: </b>{{ jsonData.documentoTotaleImponibile.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <span class="sa-label-data"><b>Totale Imposta.: </b> {{ jsonData.documentoTotaleImposta.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</span>
          </b-col>
          <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <span class="sa-label-data"><b>Totale Documento: </b> {{ jsonData.documentoTotale.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</span>
          </b-col>
        </b-row>
      </div>
    </template>
  </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin.js";
import ContabilitaDocumentoDatiViewCompontent from "../components/ContabilitaDocumentoDatiViewCompontent.vue";
import ContabilitaDocumentoRigheViewComponent from "../components/ContabilitaDocumentoRigheViewComponent.vue";
import ContabilitaRiepilogoComponent from "../components/ContabilitaRiepilogoComponent.vue";

//import DatePicker from "vue2-datepicker";
export default {
  // ContabilitaDocumentoRigheComponent,
  components: { SaPageLayout, ContabilitaDocumentoDatiViewCompontent, ContabilitaDocumentoRigheViewComponent, ContabilitaRiepilogoComponent },
  mixin: [UtilityMixin, StruttureMixin],
  data() {
    return {
      pathResource: "/contabilitadocumenti",
      keyRigheDocumento: 0,
      linkedit: "/contabilita/documenti/edit/",
      jsonData: {
        documentoTotaleImponibile: 0,
        documentoTotaleImposta: 0,
        documentoTotale: 0,
      },
    };
  },
  computed: {},
  mounted() {
    this.id = this.$route.params.id;
    this.linkedit = this.linkedit + this.id;
    this.loadData();
  },
  methods: {
    init() {
      this.$refs.cmpContabilitaDocumentoDatiViewCompontent.init(this.jsonData);
      this.$refs.cmpContabilitaDocumentoRigheViewComponent.init(this.jsonData);
      this.$refs.cmpContabilitaDocumentoRiepologoComponent.init(this.jsonData);
    },
    loadData() {
      UtilityMixin.methods.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSuccess, this.loadDataError);
    },
    loadDataSuccess(response) {
      this.jsonData = response.data.data;
      this.init();
    },
    loadDataError(error) {
      console.log(error);
    },
    onRefresh() {
      this.loadData();
    },
  },
};
</script>
